import axios from 'components/Axios';
import {
  ActivityPost,
  blockFollowers,
  getPostRelations,
  muteFollowers,
  removeorUnfollow,
  SavePost,
  followerRequest,
  followerRequestAccept,
  followerlist,
  followinglist,
  mutedfollowers,
  blockedfollowers,
  Suggestion,
  CommonPost,
  withdrawRequest,
  followRequest,
  follow,
  NonFollowerPost,
  DeletePostById,
  commonsearch,
  landingFeed,
} from '../APIEndPoint';

const ActivityPostList = (userId, currentTime, page, size, country) => {
  let promise;
  if(!country){
    promise = axios.get(
      `${CommonPost}${userId}?interactionTime=${currentTime}&page=${
        page || 0
      }&size=${size || 10}&clientOffSet=${new Date().getTimezoneOffset()}`
    );
  } else {
    promise = axios.get(
      `${NonFollowerPost}${country}?interactionTime=${currentTime}&page=${
        page || 0
      }&size=${size || 10}&clientOffSet=${new Date().getTimezoneOffset()}`
    );
  }

  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const AuthActivityPostList = (currentTime, page, size, country) => {
  const promise = axios.get(
    `${landingFeed}/${country}?interactionTime=${currentTime}&page=${
      page || 0
    }&size=${size || 10}&clientOffSet=${new Date().getTimezoneOffset()}`
  );
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const ActivityByUserPostsList = (page, size) => {
  const promise = axios.get(
    `${ActivityPost}/byUserId?page=${page || 0}&size=${size || 10}&clientOffSet=${new Date().getTimezoneOffset()}`
  );

  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const ActivityBySearchPostsList = (keyword, page, size) => {
  const promise = axios.get(
    `${commonsearch}/posts?keyword=${encodeURIComponent(keyword)}&page=${page || 0}&size=${size || 10}&clientOffSet=${new Date().getTimezoneOffset()}`
  );
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const FollowerSuggestionsList = (page, size) => {
  const promise = axios.get(`${Suggestion}?page=${page || 0}&size=${size || 10}`);

  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const AddActivityPost = (formData) => {
  const promise = axios.post(`${ActivityPost}`, formData);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const UpdateActivityPost = (payload, id) => {
  const promise = axios.put(`${ActivityPost}/${id}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetPostById = (id) => {
  const promise = axios.get(`${ActivityPost}/${id}?clientOffSet=${new Date().getTimezoneOffset()}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const DeletePost = (id, attachment) => {
  const promise = axios.delete(`${DeletePostById}`, {
    data: {
      id,
      attachment,
    },
  });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const getRelationStatus = (data) => {
  const promise = axios.get(getPostRelations, {
    params: {
      userId: data.userId,
      followerId: data.followerId || data.id,
    },
  });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const onChangeBlock = (data) => {
  const promise = axios.put(`${blockFollowers}`, {
    followerId: data.followerId,
    blockOption: data.block,
  });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const onChangeRemoveOrUnFollow = (data) => {
  const promise = axios.delete(`${removeorUnfollow}`, {
    data,
  });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const OnchangeFollowerRequest = (data) => {
  const promise = axios.post(follow, {
    followerId: data.followerId,
  });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const OnchangeFollowerRequestAccept = (data) => {
  const promise = axios({
    method: 'put',
    url: `${followerRequestAccept}`,
    data: {
      accepted: data.accepted,
      followerId: data.followerId,
    },
  });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const onChangeWithdrawRequest = (data) => {
  const promise = axios({
    method: 'put',
    url: `${withdrawRequest}`,
    data: {
      followerId: data.followerId,
      withdrawOption: true,
    },
  });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const onChangeMute = (data) => {
  const promise = axios.put(`${muteFollowers}`, {
    followerId: data.followerId,
    muteOption: data.mute,
  });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const onChangeSave = (data) => {
  const promise = axios.post(`${SavePost}`, {
    postId: data.postId,
    userId: data.userId,
  });

  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const onChangeSaveDelete = (data) => {
  const promiseDelete = axios.delete(`${SavePost}`, {
    data: {
      postId: data.postId,
      userId: data.userId,
    },
  });

  const dataPromise = promiseDelete.then((response) => response);
  return dataPromise;
};

const FollowersRequestList = (userId, page, size) => {
  const promise = axios.get(
    `${followerRequest}?page=${page || 0}&size=${size || 10}`
  );
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const FollowRequestList = (userId, page, size) => {
  const promise = axios.get(
    `${followRequest}?page=${page || 0}&size=${size || 10}`
  );
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const PostSavedList = (page, size, url) => {
  const promise = axios.get(
    `${url}?page=${page || 0}&size=${size || 10}&clientOffSet=${new Date().getTimezoneOffset()}`
  );
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const NetworkListType = (type, page, size) => {
  const pagen = `?page=${page}&size=${size}`;
  switch (type) {
    case 'follower':
      return `${followerlist}${pagen}`;
    case 'following':
      return `${followinglist}${pagen}`;
    case 'mute':
      return `${mutedfollowers}${pagen}`;
    case 'block':
      return `${blockedfollowers}${pagen}`;
  }
};

const getNetworkList = (type, page, size) => {
  const promise = axios.get(NetworkListType(type, page, size));
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export {
  ActivityPostList,
  AuthActivityPostList,
  AddActivityPost,
  UpdateActivityPost,
  GetPostById,
  ActivityByUserPostsList,
  ActivityBySearchPostsList,
  DeletePost,
  getRelationStatus,
  onChangeBlock,
  onChangeMute,
  onChangeSave,
  OnchangeFollowerRequest,
  onChangeWithdrawRequest,
  FollowersRequestList,
  FollowRequestList,
  PostSavedList,
  OnchangeFollowerRequestAccept,
  getNetworkList,
  FollowerSuggestionsList,
  onChangeSaveDelete,
  onChangeRemoveOrUnFollow,
};
